import { denormalize, normalize, schema } from 'normalizr';

const productLineConfigSchema = new schema.Entity(
  'ProductLineConfig',
  {},
  { idAttribute: (value) => (value.Line_Code ? value.Line_Code.toLowerCase() : 'line-code-missing') }
);

const productLineConfigGetSchema = new schema.Entity(
  'Transaction',
  {
    ProductLine: productLineConfigSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const productLineConfigProcessSchema = new schema.Entity(
  'Transaction',
  {
    ProductLine: productLineConfigSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneRequestSchema = new schema.Entity(
  'Request',
  {
    ProductLineConfigGet: productLineConfigGetSchema,
    ProductLineConfigProcess: productLineConfigProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

const conceptOneReplySchema = new schema.Entity(
  'Reply',
  {
    ProductLineConfigGet: productLineConfigGetSchema,
    ProductLineConfigProcess: productLineConfigProcessSchema
  },
  {
    idAttribute: (value) => '0'
  }
);

// in root ID:0 = reply from LOAD    ID:1 = transaction being built for PROCESS
export const rootSchema = new schema.Entity(
  'Root',
  {
    ConceptOneRequest: conceptOneRequestSchema,
    ConceptOneReply: conceptOneReplySchema
  },
  { idAttribute: (value) => '0' }
);

export { normalize };
export { denormalize };
